import {
  LANDING_PAGE_ROUTE,
  LANDING_PAGE_SECTION,
  LANDING_PAGE_UI,
} from '@propbix/constants/public'
import { tenantAppHref } from '@/lib/tenant-app-url'

export function SiteFooter() {
  return (
    <footer className="border-t border-line/10 bg-background">
      <div className="page-shell flex flex-col gap-8 py-12 md:flex-row md:items-end md:justify-between">
        <div className="max-w-md">
          <p className="font-display text-base font-semibold text-ink">{LANDING_PAGE_UI.brandName}</p>
          <p className="mt-2 text-sm leading-6 text-muted">{LANDING_PAGE_UI.footerTagline}</p>
        </div>
        <nav className="flex flex-wrap gap-x-5 gap-y-3 text-sm font-medium text-muted" aria-label="Footer">
          <a href={`#${LANDING_PAGE_SECTION.day}`} className="hover:text-ink">
            {LANDING_PAGE_UI.footerDayLabel}
          </a>
          <a href={`#${LANDING_PAGE_SECTION.product}`} className="hover:text-ink">
            {LANDING_PAGE_UI.footerProductLabel}
          </a>
          <a href={`#${LANDING_PAGE_SECTION.capabilities}`} className="hover:text-ink">
            {LANDING_PAGE_UI.footerPlatformLabel}
          </a>
          <a href={`#${LANDING_PAGE_SECTION.faq}`} className="hover:text-ink">
            {LANDING_PAGE_UI.faqLabel}
          </a>
          <a href={tenantAppHref(LANDING_PAGE_ROUTE.support)} className="hover:text-ink">
            {LANDING_PAGE_UI.footerSupportLabel}
          </a>
          <a href={tenantAppHref(LANDING_PAGE_ROUTE.terms)} className="hover:text-ink">
            {LANDING_PAGE_UI.footerTermsLabel}
          </a>
          <a href={tenantAppHref(LANDING_PAGE_ROUTE.privacy)} className="hover:text-ink">
            {LANDING_PAGE_UI.footerPrivacyLabel}
          </a>
          <a href={tenantAppHref(LANDING_PAGE_ROUTE.login)} className="hover:text-ink">
            {LANDING_PAGE_UI.footerLoginLabel}
          </a>
        </nav>
      </div>
    </footer>
  )
}
